import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import SignaturePad from 'node_modules/signature_pad';
import { NgForm } from '@angular/forms';
import { HttpMmtService } from 'src/app/services/http-mmt.service';
import { AuthService } from 'src/app/services/auth.service';
import { MmtVisitDetail } from 'src/app/models/mmt.model';
import { Router } from '@angular/router';
import { ListItem } from 'src/app/models/core.model';

@Component({
    selector: 'app-weedfree-form-mmt',
    templateUrl: './weedfree-form-mmt.component.html',
    styleUrls: ['./weedfree-form-mmt.component.scss']
})
export class WeedfreeFormMmtComponent implements OnInit, AfterViewInit {

    @ViewChild('sPad') signaturePadElement: ElementRef;
    @ViewChild('f') form: NgForm;

    companies: ListItem[] = [];
    machineTypes: ListItem[] = [];

    selectedCompanyId: number = 3;
    selectedMachineType: number = 1;

    signaturePad: SignaturePad;
    successMessage: string = '';
    lat: number = 0;
    lng: number = 0;
    today: Date = new Date();
    files: any[] = [];
    uploadProgress: number = 0;

    constructor(
        private router: Router,
        private http: HttpMmtService,
        private auth: AuthService) { }

    ngOnInit() {

        this.http.getFormOptions().subscribe(
            {
                next: (response) => {
                    this.companies = response.companies;
                    this.machineTypes = response.machineTypes;
                }
            });

        this.getLocation();
        this.today.setHours(12, 0, 0, 0);
    }

    ngAfterViewInit() {
        this.signaturePad = new SignaturePad(this.signaturePadElement.nativeElement);
        this.signaturePad.clear();
    }

    getLocation() {

        if (navigator.geolocation) {

            navigator.geolocation.getCurrentPosition((position) => {
                this.lat = position.coords.latitude;
                this.lng = position.coords.longitude;
            });

        }

    }

    onFileChanged(event: any) {
        this.files = event.target.files;
    }

    timeToHHMM(t: Date) {

        if (t instanceof Date)
            return ('0' + t.getHours()).slice(-2) + ':' + ('0' + t.getMinutes()).slice(-2);

        return '00:00';
    }

    onSubmit(form: NgForm) {
        // toDataURL == png format
        window.scroll(0, 0);
        this.successMessage = '';

        // fix hour offset causing prev day being submitted
        form.value.visitDate.setHours(12);

        let visit: MmtVisitDetail = {
            id: 0,
            submittedBy: this.auth.client,
            operatorName: '', // not required for this...
            visitDate: form.value.visitDate,
            company: this.selectedCompanyId,
            site: form.value.siteName,
            machine: form.value.machineName,
            machineType: this.selectedMachineType,
            signedBy: form.value.signedBy,
            startTime: this.timeToHHMM(form.value.startTime),
            finishTime: this.timeToHHMM(form.value.endTime),
            toiletEmptied: form.value.toiletEmptied ? true : false,
            toiletReplenished: form.value.toiletReplenished ? true : false,
            binEmptied: form.value.binEmptied ? true : false,
            sanitaryBinEmptied: form.value.sanitaryBinEmptied,
            floorCleaned: form.value.floorCleaned ? true : false,
            cabCleaned: form.value.cabCleaned ? true : false,
            flushingDone: form.value.flushingDone ? true : false,
            toiletRollCount: form.value.toiletRollCount,
            paperTowelCount: form.value.paperTowelCount,
            soapBarCount: form.value.soapBarCount,
            wasteWaterOut: form.value.wasteWaterOut,
            freshWaterIn: form.value.freshWaterIn,
            comments: form.value.comments,
            latitude: this.lat,
            longitude: this.lng,
            signature: this.signaturePad.toDataURL()
        }

        this.http.addVisit(visit).subscribe((response: number) => {

            if (this.files.length > 0) {
                this.successMessage = 'Uploading photos...'
                this.http.uploadVisitFiles(response, this.files).subscribe((response) => {

                    if (response.status == 'progress') {
                        this.uploadProgress = Number(response.message);
                    } else if (response.status == 'complete') {
                        this.successMessage = 'Visit successfully added and images uploaded!';

                        if (form.value.covidDone) {
                            this.router.navigate(['weedfree', 'forms', 'support-service', 'covid', response]);
                        }

                        this.uploadProgress = 0;
                    }

                }, (error) => {
                    console.log(error);
                })

            } else {
                this.successMessage = 'Visit successfully added!';

                if (form.value.covidDone) {
                    this.router.navigate(['weedfree', 'forms', 'support-service', 'covid', response]);
                }
            }

        }, (error) => {
            console.log(error);
        });
    }

}
